import { Box } from "atoms";
import React from "react";

import AddProperty from "./AddProperty";

export const PropertyListing = () => {
  return (
    <Box>
      <AddProperty />
    </Box>
  );
};
